import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import getLocale from '../../i18n/getLocale';

class LocationsIndex extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',
      },
      redirect_url: false,
      loaded: 0,
      data: []
    };
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.activate = this.activate.bind(this);
    this.archive = this.archive.bind(this);
    this.delete = this.delete.bind(this);
    this.deleteRow = this.deleteRow.bind(this);
    this.loadData = this.loadData.bind(this);
    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.refreshData = this.refreshData.bind(this);
    this.activeLayout = this.activeLayout.bind(this);
  }

  // Handlers
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData() {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/locais', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.handleMessage();
      }); /* Overlay */
    });
  }

  ActionsButtons (cell, row) {
    var url = '/local/editar/' + cell;

    var botao = (
      <div className="btn-group">
        <Link className={'btn btn-primary btn-sm'} to={url}>
          <i className="fa fa-fw fa-pencil"></i>
        </Link>
        {(row.active === 1) ?
          <button className="btn btn-sm btn-success" value={cell} onClick={this.archive}><i className="fa fa-fw fa-power-off"></i></button>
          :
          <button className="btn btn-sm btn-danger" value={cell} onClick={this.activate}><i className="fa fa-fw fa-power-off"></i></button>
        }
      </div>
    );

    return botao;
  }

  delete (event) {
    var aircraft_model_id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Locais.ListaDeLocais.deletar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/local/' + aircraft_model_id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.deleteRow(aircraft_model_id);
          }
          self.handleAlert(responseJson.message, responseJson.status, 'open');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  deleteRow(aircraft_model_id) {
    var data = this.state.data;
    data.map(function(dado, index){
      if (dado.id == aircraft_model_id) {
        data.splice(index, 1);
      }
    });
    this.setState({data: data});
  }

  refreshData (event) {
    this.handleAlert('', '', 'open');
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/locais', { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data});
        }
        if(typeof event.message !== 'undefined') {
          self.handleAlert(event.message, event.status, 'open');
        } else {
          self.handleAlert("", "", 'closed');
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }


  activate(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Locais.ListaDeLocais.ativar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var datasave = {
        id: id,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/local/ativar', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  archive(event) {
    var id = event.currentTarget.value;
    var confirm = window.confirm(this.locale.Locais.ListaDeLocais.arquivar);
    if (confirm) {
      this.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/local/arquivar/'+id, { method: 'DELETE', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.refreshData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  activeLayout (row) {
    var field = (
      <div className="btn-group">
        {(row === 1) ?
          <span className="label label-success">{this.locale.Locais.ListaDeLocais.ativo}</span>
          :
          <span className="label label-danger">{this.locale.Locais.ListaDeLocais.arquivado}</span>
        }
      </div>
    );

    return field;
  }

  render() {
    return (
<div>
  <Topo></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title pull-left">{this.locale.Locais.ListaDeLocais.titulo}</h3>
      <Link to="/local/cadastrar" className="btn btn-primary pull-right"><i className="fa fa-plus"></i> {this.locale.Locais.ListaDeLocais.botaoAdicionarLocal}</Link>
      <div className="clearfix"></div>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.Locais.ListaDeLocais.tabela.semLocais}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn dataField="id" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: ' '}} width='60'>{this.locale.Locais.ListaDeLocais.tabela.ID}</TableHeaderColumn>
        <TableHeaderColumn dataField="name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='300'>{this.locale.Locais.ListaDeLocais.tabela.Nome}</TableHeaderColumn>
        <TableHeaderColumn dataField="icao_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.Locais.ListaDeLocais.tabela.CodigoICAO}</TableHeaderColumn>
        <TableHeaderColumn dataField="iata_code" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.Locais.ListaDeLocais.tabela.CodigoIATA}</TableHeaderColumn>
        <TableHeaderColumn dataField="location_type_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Locais.ListaDeLocais.tabela.Tipo}</TableHeaderColumn>
        <TableHeaderColumn dataField="city" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='200'>{this.locale.Locais.ListaDeLocais.tabela.Cidade}</TableHeaderColumn>
        <TableHeaderColumn dataField="coordinate_lat" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.Locais.ListaDeLocais.tabela.CoordenadaLat}</TableHeaderColumn>
        <TableHeaderColumn dataField="coordinate_long" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.Locais.ListaDeLocais.tabela.CoordenadaLong}</TableHeaderColumn>
        <TableHeaderColumn dataField="shore" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='150'>{this.locale.Locais.ListaDeLocais.tabela.Shore}</TableHeaderColumn>
        <TableHeaderColumn dataField="active" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}} width='100' dataFormat={this.activeLayout}>{this.locale.Locais.ListaDeLocais.tabela.Status}</TableHeaderColumn>
        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.Locais.ListaDeLocais.tabela.Acoes}</TableHeaderColumn>

      </BootstrapTable>
    </div>
  </div>
</div>
    );
  }
}

export default LocationsIndex;



// WEBPACK FOOTER //
// ./src/Components/Locations/LocationsIndex.js